export default {"src":"/_next/static/media/ico-arrow-top.721775e5.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};